<div id="create-tender-review" class="container py-5 has-floating-actions">
  <div class="row justify-content-center">
    <div class="col-lg-8">
      <!-- Tender Details Card -->
      <div class="card shadow-sm border-0 rounded-4 overflow-hidden mb-4">
        <div class="card-header py-4">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="icon-box bg-primary-subtle text-primary rounded-3 p-2 me-3">
                <i class="bi bi-clipboard-check fs-4"></i>
              </div>
              <div>
                <h3 class="mb-0 fw-bold">Tender Details</h3>
                <p class="text-muted mb-0">Review your tender parameters</p>
              </div>
            </div>
            <button (click)="exportTender()" class="btn btn-sm btn-outline-primary rounded-pill">
              <i class="bi bi-download me-1"></i>
              Export
            </button>
          </div>
        </div>
        <div class="card-body p-4">
          <div class="review-field mb-3">
            <div class="review-label">Tender Name</div>
            <div class="review-value">{{ tender.name }}</div>
          </div>
          <div class="review-field mb-3">
            <div class="review-label">Round 1 Closing Date</div>
            <div class="review-value">
              <jft-datetime [date]="toDate(tender.dateRoundEnd.format('YYYY-MM-DD HH:mm:ss'))"></jft-datetime>
            </div>
          </div>
          <div class="row g-3">
            <div class="col-md-6">
              <div class="review-field">
                <div class="review-label">Tender Start Date</div>
                <div class="review-value">
                  <jft-datetime [date]="toDate(tender.dateContractStart.format('YYYY-MM-DD HH:mm:ss'))"></jft-datetime>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="review-field">
                <div class="review-label">Tender End Date</div>
                <div class="review-value">
                  <jft-datetime [date]="toDate(tender.dateContractEnd.format('YYYY-MM-DD HH:mm:ss'))"></jft-datetime>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cover Letter & Documents Card -->
      <div class="card shadow-sm border-0 rounded-4 overflow-hidden mb-4">
        <div class="card-header py-4">
          <div class="d-flex align-items-center">
            <div class="icon-box bg-primary-subtle text-primary rounded-3 p-2 me-3">
              <i class="bi bi-envelope-paper fs-4"></i>
            </div>
            <div>
              <h3 class="mb-0 fw-bold">Cover Letter & Documents</h3>
              <p class="text-muted mb-0">Attached materials for this tender</p>
            </div>
          </div>
        </div>
        <div class="card-body p-4">
          <div *ngIf="coverLetter" class="mb-4">
            <div class="review-label mb-2">Cover Letter</div>
            <jft-cover-letter [coverLetter]="coverLetter" [tenderId]="tender.id"></jft-cover-letter>
          </div>
          <div *ngIf="documents.length">
            <div class="review-label mb-2">Uploaded Documents</div>
            <jft-document-list [tenderId]="tender.id" [documents]="documents"
              (documentDownloaded)="docDownloadedEvent($event)" [readonly]="true">
            </jft-document-list>
          </div>
          <div *ngIf="requestedDocuments.length" [class.mt-4]="documents.length || coverLetter">
            <div class="review-label mb-2">Requested Documents</div>
            <ul class="mb-0 ps-3">
              <li *ngFor="let document of requestedDocuments" class="text-body-secondary">
                {{ document.name }}
              </li>
            </ul>
          </div>
          <div *ngIf="!coverLetter && !documents.length && !requestedDocuments.length"
            class="text-center py-3 text-muted">
            <i class="bi bi-file-earmark-x fs-3 d-block mb-2 opacity-50"></i>
            No documents attached
          </div>
        </div>
      </div>

      <!-- Locations Card -->
      <div class="card shadow-sm border-0 rounded-4 overflow-hidden mb-4">
        <div class="card-header py-4">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="icon-box bg-primary-subtle text-primary rounded-3 p-2 me-3">
                <i class="bi bi-geo-alt fs-4"></i>
              </div>
              <div>
                <h3 class="mb-0 fw-bold">
                  Locations
                  <span class="badge bg-primary-subtle text-primary ms-2 fw-semibold"
                    style="font-size: 0.75rem;">{{totalItems}}</span>
                </h3>
                <p class="text-muted mb-0">Airports included in this tender</p>
              </div>
            </div>
            <div class="search-box">
              <i class="bi bi-search search-icon"></i>
              <input type="text" class="form-control form-control-sm rounded-pill" placeholder="Search locations..."
                [(ngModel)]="locationSearch" (ngModelChange)="onLocationSearchChange($event)">
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover mb-0 review-table">
              <thead>
                <tr>
                  <th>Airport</th>
                  <th *ngIf="!tender.company.settings.isHiddenField('location_company')">Company</th>
                  <th *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">Fuel Type</th>
                  <th *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">Flight Type</th>
                  <th *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">Delivery Point</th>
                  <th>{{tender.company.settings.getFieldName('total_volume', 'Yearly Volume')}}</th>
                  <th class="text-center">Settings</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let contract of contracts">
                  <td>
                    <strong>{{ contract.location.iata }}</strong>
                  </td>
                  <td *ngIf="!tender.company.settings.isHiddenField('location_company')">
                    <span *ngIf="contract.companyChild && contract.companyChild?.name">{{
                      contract.companyChild?.getDisplayName() }}</span>
                    <span *ngIf="!(contract.companyChild && contract.companyChild?.name)">{{ contract.companyInfo
                      }}</span>
                  </td>
                  <td *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
                    <span *ngIf="contract.fuelType?.name">{{tender.company.settings.getFilteredOptionLabel('fuel_type',
                      contract.fuelType)}}</span>
                  </td>
                  <td *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
                    <span *ngIf="contract.flightType?.name">{{contract.flightType.name}}</span>
                  </td>
                  <td *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
                    <span
                      *ngIf="contract.fuelPreference?.name">{{tender.company.settings.getFilteredOptionLabel('delivery_point',
                      contract.fuelPreference)}}</span>
                  </td>
                  <td>
                    {{ contract.volume | usNumber }}
                  </td>
                  <td class="text-center">
                    <ng-template #tipContent>
                      <div class="text-start">
                        <div *ngIf="contract.dateStart && contract.dateEnd">
                          Contract start date: <strong>{{contract.dateStart | date: defaultDateFormat :
                            'utc'}}</strong><br>
                          Contract end date: <strong>{{contract.dateEnd | date: defaultDateFormat : 'utc'}}</strong><br>
                        </div>
                        <div *ngIf="contract.currency?.code">
                          Preferred currency: <strong>{{contract.currency.code}}</strong><br>
                        </div>
                        <div *ngIf="contract.units?.code">
                          Preferred units: <strong>{{contract.units.code}}</strong><br><br>
                        </div>

                        <div
                          *ngIf="!tender.company.settings.isHiddenField('location_annual_frequency') && contract.annualFrequency">
                          Annual frequency: <strong>{{contract.annualFrequency}}</strong><br>
                        </div>
                        <div
                          *ngIf="!tender.company.settings.isHiddenField('location_annual_frequency') && contract.averageUplift">
                          Average uplift: <strong>{{contract.averageUplift}}</strong><br>
                        </div>
                        <div
                          *ngIf="!tender.company.settings.isHiddenField('location_months_of_service') && contract.monthService">
                          Months of service: <strong>{{contract.monthService}}</strong><br>
                        </div>
                        <div
                          *ngIf="!tender.company.settings.isHiddenField('location_monthly_volume') && contract.monthService && contract.volume">
                          Monthly volume: <strong>{{contract.volume / contract.monthService | number : '1.0-0' |
                            usNumber }} {{
                            contract.units.code }}</strong><br>
                        </div>
                        <div
                          *ngIf="!tender.company.settings.isHiddenField('location_award_quota') && contract.awardQuota">
                          Award quota: <strong>{{ contract.awardQuota }}%</strong><br>
                        </div>
                        <div
                          *ngIf="!tender.company.settings.isHiddenField('location_branded')">
                          Branded: <strong>{{ contract.branded ? 'Yes' : 'No' }}</strong><br>
                        </div>
                        <div *ngIf="!tender.company.settings.isHiddenField('location_notes') && contract.notes"><br>
                          Notes:<br>{{contract.notes}}<br>
                        </div>
                        <div
                          *ngIf="!tender.company.settings.isHiddenField('location_iata_service_level') && contract.iataServiceLevel?.name">
                          IATA Service Level: <strong>{{contract.iataServiceLevel.name}}</strong><br>
                        </div>
                        <div *ngIf="!tender.company.settings.isHiddenField('location_preferred_index')">
                          <div *ngIf="contract.plattsIndexSettings">
                            Price Base: <strong>{{ contract.plattsIndexSettings.index?.getLabel() }} {{
                              contract.plattsIndexSettings.getAdditionalLabel() }} {{
                              contract.plattsIndexSettings.getTimePeriodLabel() }}</strong><br>
                          </div>
                          <div *ngIf="contract.argusIndexSettings">
                            Price Base: <strong>{{ contract.argusIndexSettings.index?.getLabel() }} {{
                              contract.argusIndexSettings.getAdditionalLabel() }} {{
                              contract.argusIndexSettings.getTimePeriodLabel() }}</strong><br>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <a href="javascript:void(0);" placement="left" [ngbTooltip]="tipContent" class="text-primary">
                      <i class="bi bi-gear"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Load More -->
          <div class="text-center py-3 border-top" *ngIf="contracts.length < totalItems">
            <button class="btn btn-outline-primary btn-sm rounded-pill px-4" (click)="loadMore()"
              [disabled]="loadingMore">
              <span *ngIf="!loadingMore">
                <i class="bi bi-arrow-down-circle me-1"></i>
                Load More ({{ contracts.length }} of {{ totalItems }})
              </span>
              <span *ngIf="loadingMore">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                Loading...
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Fuel Suppliers Card -->
      <div class="card shadow-sm border-0 rounded-4 overflow-hidden mb-5">
        <div class="card-header py-4">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="icon-box bg-primary-subtle text-primary rounded-3 p-2 me-3">
                <i class="bi bi-people fs-4"></i>
              </div>
              <div>
                <h3 class="mb-0 fw-bold">
                  Fuel Suppliers
                  <span class="badge bg-primary-subtle text-primary ms-2 fw-semibold"
                    style="font-size: 0.75rem;">{{uniqueSupplierCompaniesCount}}
                    compan{{uniqueSupplierCompaniesCount !== 1 ? 'ies' : 'y'}}</span>
                  <span class="badge bg-light text-body-secondary ms-1 fw-semibold"
                    style="font-size: 0.75rem;">{{tenderInvitedSupplierUsers.length}}
                    user{{tenderInvitedSupplierUsers.length !== 1 ? 's' : ''}}</span>
                </h3>
                <p class="text-muted mb-0">Invited supplier contacts</p>
              </div>
            </div>
            <div class="search-box">
              <i class="bi bi-search search-icon"></i>
              <input type="text" class="form-control form-control-sm rounded-pill" placeholder="Search suppliers..."
                [(ngModel)]="supplierSearch" (ngModelChange)="onSupplierSearchChange()">
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover mb-0 review-table">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Last Name</th>
                  <th>First Name</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let supplier of visibleSuppliers">
                  <td>
                    {{supplier.company.name}}
                    <span *ngIf="supplier.supplierAlias" class="small text-muted"> ({{supplier.supplierAlias}})</span>
                  </td>
                  <td>{{supplier.lastName}}</td>
                  <td>{{supplier.firstName}}</td>
                  <td>{{supplier.email}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Load More Suppliers -->
          <div class="text-center py-3 border-top" *ngIf="visibleSupplierCount < filteredSuppliers.length">
            <button class="btn btn-outline-primary btn-sm rounded-pill px-4" (click)="loadMoreSuppliers()">
              <i class="bi bi-arrow-down-circle me-1"></i>
              Load More ({{ visibleSupplierCount }} of {{ filteredSuppliers.length }})
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="col-lg-4">
      <div class="sidebar-card shadow-sm border-0 rounded-4 sticky-top" style="top: 2rem;">
        <h5 class="fw-bold mb-3">
          <i class="bi bi-send text-primary me-2"></i>
          Ready to Launch?
        </h5>
        <p class="text-muted small mb-3">Review all details carefully before launching your tender. Once launched,
          suppliers will be notified immediately.</p>
        <div class="checklist-item">
          <div class="checklist-circle"></div>
          <div>
            <div class="fw-semibold">Tender parameters configured</div>
          </div>
        </div>
        <div class="checklist-item">
          <div class="checklist-circle"></div>
          <div>
            <div class="fw-semibold">{{totalItems}} location{{totalItems !== 1 ? 's' : ''}} added</div>
          </div>
        </div>
        <div class="checklist-item">
          <div class="checklist-circle"></div>
          <div>
            <div class="fw-semibold">{{uniqueSupplierCompaniesCount}} supplier{{uniqueSupplierCompaniesCount !== 1 ? 's'
              : ''}} invited</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<jft-submission-footer data-testid="wizard-next" backLabel="Back" backIcon="bi-arrow-left" nextLabel="Launch Tender"
  nextIcon="bi-send"
  secondaryNextLabel="Delete Draft" secondaryNextClass="btn btn-link text-danger text-decoration-none fw-bold"
  [nextLoading]="loading" [nextDisabled]="loading" (onBack)="stepBack()" (onNext)="launchTender()"
  (onSecondaryNext)="deleteTender()">
</jft-submission-footer>